<!--协同备课、听评课数量时间分布图-->
<template>
    <div class="my-charts">
        <div :id="id" style="margin-top: -40px;"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";

let lineChart = null;

export default {
    name: "evaYearTimeEchart",
    props: {
        id:{
            type: String,
            default:"eva_year_time_echart"
        },
        monthList:{
            type: Array,
            default:['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月']
        },
        oneCountList:{
            type: Array,
            default:[0,0,0,0,0,0,0,0,0,0,0,0]
        },
        twoCountList:{
            type: Array,
            default:[0,0,0,0,0,0,0,0,0,0,0,0]
        },
        threeCountList:{
            type: Array,
            default:[0,0,0,0,0,0,0,0,0,0,0,0]
        },
    },
    watch:{
    },
    data() {
        return {
            ml:['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],
            chartOption:{
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis',
                },
                color: [
                    '#ee6666',
                    '#91cc75',
                    '#3ba272',
                    '#fc8452',
                    '#9a60b4',
                    '#ea7ccc',
                ],
                legend: {
                    data: ['推门听课', '录播听课','直播听课'],
                    bottom:'1%',
                    axisLabel: {
                        show: true,
                        interval:0,
                        rotate:0,
                        textStyle: {    //文字样式
                            color: "black",
                            fontSize: 10,
                        }
                    },
                },
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        show: true,
                        interval:0,
                        rotate:0,
                        textStyle: {    //文字样式
                            color: "black",
                            fontSize: 10,
                        }
                    },
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '推门听课',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '录播听课',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '直播听课',
                        type: 'line',
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            lineChart = echarts.init(document.getElementById(this.id));
            this.chartOption.xAxis.data = this.monthList;
            this.chartOption.series[0].data = this.oneCountList;
            this.chartOption.series[1].data = this.twoCountList;
            this.chartOption.series[2].data = this.threeCountList;
            this.chartOption&&lineChart.setOption(this.chartOption);
        }
    }
};
</script>

<style scoped lang="scss">
.my-charts {
    width: 100%;
    height: calc(50vh - 80px);
    flex-direction: column;
    div {
        width: 100%!important;
        height: calc(50vh - 90px);
    }
}
</style>